import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Box,
  Toolbar
} from "@mui/material";
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../../../styles/SideBar.css";
import Logo from "../../../assets/Atithiseva-Logo-Final-1024x298.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { adminMenuItems } from "./adminMenuItems";
import { vendorMenuItems } from "./vendorMenuItems";
import { customerMenuItems } from "./customerMenuItems";
import { useDispatch } from "react-redux";
import { LOGIN } from "../Routes/AppRoutes";
import { logoutRequest } from "../../../redux/auth/actions/authActions";

const getMenuItemsByRole = (role) => {
  switch (role) {
    case "Admin":
      return adminMenuItems;
    case "Staff":
      return adminMenuItems;
    case "Vendor":
      return vendorMenuItems;
    case "Customer":
      return customerMenuItems;
    default:
      return [];
  }
};

const SideBar = ({ userRole, isDrawerOpen, handleDrawerToggle }) => {
  const location = useLocation();
  const menuItems = getMenuItemsByRole(userRole);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutRequest());
    localStorage.clear();
    navigate(LOGIN);
  };

  return (
    <Drawer
      variant="persistent"
      open={isDrawerOpen}
      sx={{
        width: isDrawerOpen ? 240 : 0,
        flexShrink: 0,
        position: { xs: "absolute", lg: "relative" },
        "& .MuiDrawer-paper": {
          width: isDrawerOpen ? 240 : 0,
          boxSizing: "border-box",
          backgroundColor: "#ffffff",
          color: "#000000",
          boxShadow: "2px 0px 8px rgba(0, 0, 0, 0.1)",
          transition: "width 0.3s ease"
        }
      }}
    >
      <Toolbar className="sidebar-toolbar">
        <IconButton onClick={handleDrawerToggle} className="sidebar-close-icon">
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>

      <Box className={`sidebar-logo ${isDrawerOpen ? "" : "hidden"}`}>
        <img src={Logo} alt="Logo" />
      </Box>

      <PerfectScrollbar
        options={{
          suppressScrollX: true
        }}
        style={{
          maxHeight: "calc(100% - 100px)"
        }}
      >
        <List>
          {menuItems.map((item, index) => {
            const isActive =
              location.pathname === item.path ||
              (item.path !== LOGIN && location.pathname.startsWith(item.path));

            return (
              <React.Fragment key={index}>
                {item.action === "logout" ? (
                  <ListItem
                    button
                    className="sidebar-list-item"
                    onClick={handleLogout}
                  >
                    <ListItemIcon
                      className={`sidebar-icon ${isActive ? "active" : ""}`}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText primary={item.text} />}
                  </ListItem>
                ) : (
                  <Link
                    to={item.path}
                    className={`sidebar-link ${isActive ? "active" : ""}`}
                  >
                    <ListItem button className="sidebar-list-item">
                      <ListItemIcon
                        className={`sidebar-icon ${isActive ? "active" : ""}`}
                      >
                        {item.icon}
                      </ListItemIcon>
                      {isDrawerOpen && <ListItemText primary={item.text} />}
                    </ListItem>
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </List>
      </PerfectScrollbar>
    </Drawer>
  );
};

export default SideBar;
